module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("Icons")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Several components uses icons, you might want to add a pack")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "title": "Material Design Icons CDN",
      "code": _vm.materialIcons,
      "expanded": ""
    }
  }), _vm._v(" "), _c('CodeView', {
    attrs: {
      "title": "Font Awesome 5 CDN",
      "code": _vm.fontAwesome5,
      "expanded": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_c('p', [_vm._v("Refer to its documentation for latest release / CDN.")]), _vm._v(" "), _c('p', [_vm._v("Please note that Buefy doesn't include icon packs. You have to import it as you prefer (NPM, CDN, etc.).")]), _vm._v(" "), _c('p', [_vm._v("\n                    If you opted for Font Awesome, you should update your\n                    "), _c('router-link', {
    attrs: {
      "to": "/documentation/constructor-options"
    }
  }, [_vm._v("constructor options")]), _vm._v(".\n                ")], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-warning",
      "size": "is-medium"
    }
  }, [_vm._v("\n            For any installation and usage method, you need\n            "), _c('strong', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Vue.js")]), _vm._v(" version 2.5+")]), _vm._v(".\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-spaced"
  }, [_vm._v("After creating a project with vue-cli or custom-made (usually Webpack)")]), _vm._v(" "), _c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Installation")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "code": "npm install buefy",
      "lang": "bash",
      "expanded": ""
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "title is-4"
  }, [_vm._v("Usage")]), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-success"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n                        Even though this is gonna import "), _c('strong', [_vm._v("ALL")]), _vm._v(" components to your application,\n                        Buefy full bundle is optimized and still pretty small:\n                        "), _c('ul', [_c('li', [_c('strong', [_vm._v("script")]), _vm._v(" is "), _c('strong', [_vm._v("32KB")]), _vm._v(" min+gzip")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("style")]), _vm._v(" is "), _c('strong', [_vm._v("28KB")]), _vm._v(" min+gzip (with bulma included)")])])])]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "title": "Full bundle (recommended)",
      "code": _vm._f("pre")(_vm.importingBundle),
      "lang": "javascript",
      "expanded": ""
    }
  }), _vm._v(" "), _c('CodeView', {
    attrs: {
      "title": "Individual components as Vue plugins",
      "code": _vm._f("pre")(_vm.importingComponentsAsVuePlugins),
      "lang": "javascript",
      "expanded": ""
    }
  }), _vm._v(" "), _c('b-message', {
    attrs: {
      "type": "is-info"
    }
  }, [_vm._v("\n                    To include individual styles, see "), _c('router-link', {
    attrs: {
      "to": "/documentation/customization"
    }
  }, [_vm._v("Customization")]), _vm._v(" section.\n                ")], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Standalone")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-spaced"
  }, [_vm._v("Using CDN or downloading files to serve local")]), _vm._v(" "), _c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Installation")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Usage example")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "code": _vm._f("pre")(_vm.importingCDNHtml),
      "expanded": ""
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Nuxt.js")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-spaced"
  }, [_vm._v("Using a Nuxt.js module to keep things easier")]), _vm._v(" "), _c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Installation")]), _vm._v(" "), _c('CodeView', {
    attrs: {
      "code": "npm install nuxt-buefy",
      "lang": "bash",
      "expanded": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title is-4"
  }, [_vm._v("Usage")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('CodeView', {
    attrs: {
      "code": _vm._f("pre")(_vm.importingNuxtBuefy),
      "lang": "javascript",
      "expanded": ""
    }
  })], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("NPM or Yarn "), _c('em', [_vm._v("(recommended)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Just download or use these as CDN:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Script: "), _c('a', {
    attrs: {
      "href": "https://unpkg.com/buefy/dist/buefy.min.js",
      "target": "_blank"
    }
  }, [_vm._v("https://unpkg.com/buefy/dist/buefy.min.js")])]), _vm._v(" "), _c('li', [_vm._v("Style: "), _c('a', {
    attrs: {
      "href": "https://unpkg.com/buefy/dist/buefy.min.css",
      "target": "_blank"
    }
  }, [_vm._v("https://unpkg.com/buefy/dist/buefy.min.css")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("3")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "content"
  }, [_vm._v("\n                    Add "), _c('a', {
    attrs: {
      "href": "https://github.com/buefy/nuxt-buefy"
    }
  }, [_vm._v("nuxt-buefy")]), _vm._v(" to modules section of "), _c('code', [_vm._v("nuxt.config.js")]), _vm._v(":\n                ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7460c4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/installation/Start.vue
// module id = 1592
// module chunks = 61